import axios from "axios";
import { GET_LAND_AGGREGATE_DATA } from "../../apollo/queries";
import { graphEndpoint } from "../../helper/subgraphs";

export interface AggregateLandModel {
  id: string;
  price: string;
  coordinates: {
    x: number;
    y: number;
  };
  isMinted?: boolean;
}
export enum LandTiers {
  tier1 = 'tier1',
  tier2 = 'tier2',
  tier3 = 'tier3',
  tier4 = 'tier4',
}

const fetchAggregateLands = async (
  tier: LandTiers,
  nLands: number
): Promise<Array<AggregateLandModel>> => {
  const GET_LAND_AGGREGATE_DATA_ENDPOINT = graphEndpoint(true);
  const GET_LAND_AGGREGATE_DATA_DATA: any = await axios.post(GET_LAND_AGGREGATE_DATA_ENDPOINT, {
    query: GET_LAND_AGGREGATE_DATA(tier, nLands)
  });
  if (GET_LAND_AGGREGATE_DATA_DATA.data.data.landInfos.length > 0) {
    return GET_LAND_AGGREGATE_DATA_DATA.data.data.landInfos as Array<AggregateLandModel>;
  } else throw new Error('Error fetching lands');
};

export const AggregateLandService = {
  fetchAggregateLands,
};
